const dataFormations = [
    {
        id:1,
        title:"Mastère 2 Informatique",
        date:"01/10/2022 - 30/09/2023",
        location:"ÉSTIAM Tarbes, 65000 Tarbes",
        contenus : [
            {
                id:1,
                title:"Spécialité Data et Application Design",
            },
            {
                id:2,
                title:"Applications Hybrides : Ionic",
            },
            {
                id:3,
                title:"Phaser3 / NodeJS / ExpressJS / Socket.io",
            },
            {
                id:4,
                title:"POO C# : Xamarin, ASP.NET Core",
            },
            {
                id:5,
                title:"Cursus métiers : E-INDUSTRIES ",
            }
        ]
    },
    {
        id:2,
        title:"Mastère 1 Informatique",
        date:"01/10/2021 - 31/09/2022",
        location:"ÉSTIAM Tarbes, 65000 Tarbes",
        contenus : [
            {
                id:1,
                title:"Spécialité Data et Application Design",
            },
            {
                id:2,
                title:"ReactJS / NodeJS / ExpressJS ",
            },
            {
                id:3,
                title:"Méthode SCRUM / Amazon Web Services ",
            },
            {
                id:3,
                title:"Cursus métiers : E-INDUSTRIES ",
            }
        ]
    },
    {
        id:3,
        title:"Bachelor Informatique",
        date:"01/10/2020 - 31/09/2021",
        location:"ÉSTIAM Tarbes, 65000 Tarbes",
        contenus : [
            {
                id:1,
                title:"Spécialité Data et Application Design",
            },
            {
                id:2,
                title:"JS / C# / Kotlin / Go",
            },
            {
                id:3,
                title:"ITIL / SEO / Web marketing / Business Intelligence",
            }
        ]
    },
    {
        id:4,
        title:"BTS Systèmes Numériques",
        date:"01/09/2018 - 01/07/2020",
        location:"Lycée Pradeau-La Sède-St Pierre, 65000 Tarbes",
        contenus : [
            {
                id:1,
                title:"Option : Informatique et Réseaux",
            },
            {
                id:2,
                title:"C / C++ / HTML / Python / PHP / MySQL",
            }
        ]
    },
    {
        id:5,
        title:"Baccalauréat Scientifique",
        date:"01/09/2015 - 01/07/2018",
        location:"Lycée Général et Technologique Marie Curie, 65000 Tarbes",
        contenus : [
            {
                id:1,
                title:"Spécialite Informatique et Sciences du Numérique",
            },
        ]
    },
]

export default dataFormations